import React from 'react';

import classNames from 'classnames';

import styles from './CircledArrows.module.css';

export type Props = {
  className?: string;
  color?: string;
  height?: number;
  isRotating?: boolean;
  onClick?: (() => void) | React.MouseEventHandler<Element>;
  width?: number;
};

export const CircledArrows = React.memo((props: Props) => {
  const {
    width = 24,
    height = 24,
    className,
    color = '#0f0a1b',
    onClick,
    isRotating = false,
  } = props;

  return (
    <svg
      width={width}
      height={height}
      className={classNames(
        { [styles.rotating]: isRotating },
        className,
      )}
      onClick={onClick}
    >
      <g viewBox='0 0 24 24' fill='none'>
        <path d='M6 3L3.70711 5.29287C3.31658 5.68339 3.31658 6.31656 3.7071 6.70708L6 9' stroke={color} strokeWidth='3' strokeLinecap='round' />
        <path d='M18 21L20.2929 18.7071C20.6834 18.3166 20.6834 17.6834 20.2929 17.2929L18 15' stroke={color} strokeWidth='3' strokeLinecap='round' />
        <path d='M5 6C5 6 13 6 16 6C19 6 20 7 20 10' stroke={color} strokeWidth='3' strokeLinecap='round' />
        <path d='M20 18C20 18 11 18 8 18C5 18 4 17 4 14' stroke={color} strokeWidth='3' strokeLinecap='round' />
      </g>
    </svg>
  );
});

CircledArrows.displayName = 'CircledArrows';
